import React from 'react';
import { Radio as AntRadio } from 'antd';
import classNames from 'classnames';
import styles from './radio.module.scss';

const Radio = (props) => {
  const { className, children, ...rest } = props;

  return (
    <span className={styles.radio}>
      <AntRadio
        className={classNames({
          [className]: true,
        })}
        {...rest}
      >
        {children}
      </AntRadio>
    </span>
  );
};

Radio.Group = AntRadio.Group;

export default Radio;
